
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"b"}},[_c('path',{attrs:{"data-name":"Rettangolo 48","fill":"#fff","d":"M0 0h462.216v483.259H0z"}})]),_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h500v500H0z"}})])]),_c('g',{attrs:{"data-name":"Formato personalizzato – 2"}},[_c('g',{attrs:{"data-name":"Raggruppa 2","clip-path":"url(#a)"}},[_c('g',{attrs:{"data-name":"Raggruppa 1","clip-path":"url(#b)","transform":"translate(18.892 8.37)"}},[_c('path',{attrs:{"data-name":"Tracciato 254","d":"M73.524 451.742h315.168v-57.109a10.506 10.506 0 00-2.784-7.123l-88.615-96a73.54 73.54 0 010-99.761l88.615-96a10.5 10.5 0 002.784-7.123V31.517H73.524v57.108a10.5 10.5 0 002.784 7.123l88.614 96a73.538 73.538 0 010 99.761l-88.615 96a10.509 10.509 0 00-2.783 7.123zm346.685 0h26.264a15.759 15.759 0 010 31.517H15.743a15.759 15.759 0 010-31.517h26.264v-57.109a42.025 42.025 0 0111.136-28.5l88.625-96a42.023 42.023 0 000-57l-88.615-96a42.023 42.023 0 01-11.146-28.5V21.011A21.011 21.011 0 0163.018 0H399.2a21.011 21.011 0 0121.011 21.011v67.614a42.022 42.022 0 01-11.136 28.5l-88.625 96a42.021 42.021 0 000 57l88.615 96a42.027 42.027 0 0111.146 28.5zM125 420.668a14.047 14.047 0 01-12.549-25.135 265.337 265.337 0 01237.3 0 14.047 14.047 0 01-12.549 25.135 237.239 237.239 0 00-212.202 0zM337.211 71.021a14.047 14.047 0 0112.549 25.135 265.33 265.33 0 01-237.3 0A14.047 14.047 0 01125 71.021a237.239 237.239 0 00212.211 0z","fill":"#fff"}})])])])])
          )
        }
      }
    